export default __webpack_public_path__ + "static/Tek_Crop_Plot-85f9ef3cd7fe98409cbaf03e737f8c81.png";